module.exports = __webpack_public_path__ + "static/carbon-table-striped-398ac117262fc7745b893c8b48eab27c.png";